import * as React from "react";

const SvgIcnAgentsView = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.557 15.067a4.5 4.5 0 014.5 4.5.5.5 0 11-1 0 3.5 3.5 0 00-3.5-3.5H8.51a3.5 3.5 0 00-3.5 3.5.5.5 0 11-1 0 4.5 4.5 0 014.5-4.5zM12 3a5 5 0 110 10 5 5 0 010-10zm0 1a4 4 0 100 8 4 4 0 000-8z"
        />
    </svg>
);

export default SvgIcnAgentsView;
